export default "__VITE_ASSET__DQS2gTV8__"